import React, { useEffect, useState, useContext } from "react";
import { Menu, Select, message, Form } from "antd";
import { useSelector } from "react-redux";
import {
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  THEME_TYPE_LITE,
} from "../../constants/ThemeSetting";
import { Link } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";
import { useAuth } from "../../authentication";
import CustomScrollbars from "util/CustomScrollbars";
import IntlMessages from "../../util/IntlMessages";
import SidebarLogo from "./SidebarLogo";
import UserProfile from "./UserProfile";
import ClientsAPI from "../../services/Clients/Clients";
import { CorporateAdminContextApi } from "../../contextApi/CorporateAdminContext";
import "./sidebar.css";

const clientsApi = new ClientsAPI();

const SidebarContent = ({ sidebarCollapsed, setSidebarCollapsed }) => {
  // Context API content
  const { setCAdminClientId } = useContext(CorporateAdminContextApi);

  const [activePathname, setActivePathname] = useState("");
  const [clientList, setClientList] = useState([]);
  const { navStyle, themeType } = useSelector(({ settings }) => settings);
  const { authUser } = useAuth();
  const [form] = Form.useForm();
  const pathname = useSelector(({ common }) => common.pathname);

  const getNoHeaderClass = (navStyle) => {
    if (
      navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR ||
      navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR
    ) {
      return "gx-no-header-notifications";
    }
    return "";
  };

  // Get client list
  const getClientList = async () => {
    try {
      const cookieCAdminClientId = localStorage.getItem("cAdminClientId");

      // fetching client list
      let payload = {
        search: "",
      };
      const response = await clientsApi.getAllClientBasics(payload);
      if (response && response.data) {
        let defaultValue = {
          id: 0,
          name: "All"
        }
        let clientList = response.data;
        clientList.unshift(defaultValue);
        
        await setClientList(clientList);

        // set default value of client dropdown
        if (authUser.role === "corporateAdmin") {
          if(cookieCAdminClientId && cookieCAdminClientId > -1) {
            setCAdminClientId(parseInt(cookieCAdminClientId));
            form.setFieldsValue({
              cAdminClients: parseInt(cookieCAdminClientId),
            });
          } else {
            localStorage.setItem('cAdminClientId', parseInt(clientList[0].id));
            setCAdminClientId(parseInt(clientList[0].id));
            form.setFieldsValue({
              cAdminClients: clientList[0].id,
            });
          }
        }
      }
    } catch (error) {
      message.error("Something went wrong, please try again later.");
    }
  };

  const selectedKeys = pathname.substr(1);
  const defaultOpenKeys = selectedKeys.split("/")[1];

  useEffect(() => {
    if (authUser.role === "corporateAdmin") {
      getClientList();
    }

    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    // Check and set Active tab in sidebar
    const extractDynamicDigit = (pathname) => {
      // Define regular expressions for both path formats
      const clintUpdatePattern = /\/clients\/updateClient\/(\d+)/;
      const updateAssetPattern = /\/assets\/updateAsset\/(\d+)/;
      const clientAssetPattern = /\/assets\/allAssets\/(\d+)/;
      const updateUserPattern = /\/users\/editUser\/(\d+)/;
      const clientUsersPattern = /\/users\/allUsers\/(\d+)/;
      const cAdminUpdatePattern = /\/corporateadmin\/updateAdmin\/(\d+)/;
      let newPathName = "";
      if (
        pathname === "/dashboard/crm" ||
        pathname === "/dashboardData/metal" ||
        pathname === "/dashboardData/style" ||
        pathname === "/dashboardData/size" ||
        pathname === "/dashboardData/shape" ||
        pathname === "/dashboardData/downloadsincelastlogin" ||
        pathname === "/dashboardData/savedrings" ||
        pathname === "/dashboardData/appointmentclicks" ||
        pathname === "/dashboardData/sharedlist" ||
        pathname === "/dashboardData/leadsassigned" 
      ) {
        newPathName = "1";
      } else if (clintUpdatePattern.test(pathname)) {
        newPathName = "3";
      } else if (updateAssetPattern.test(pathname)) {
        newPathName = "2";
      } else if (clientAssetPattern.test(pathname)) {
        newPathName = "2";
      } else if (updateUserPattern.test(pathname)) {
        newPathName = "4";
      } else if (clientUsersPattern.test(pathname)) {
        newPathName = "4";
      } else if (pathname === "/clients/addClient") {
        newPathName = "3";
      } else if (pathname === "/assets/addAsset") {
        newPathName = "2";
      } else if (pathname === "/assets/categories") {
        newPathName = "2";
      } else if (
        pathname === "/corporateadmin/allAdmins" ||
        pathname === "/corporateadmin/addAdmin" ||
        pathname === "/corporateadmin/updateAdmin" ||
        cAdminUpdatePattern.test(pathname)
      ) {
        newPathName = "5";
      }
      return newPathName;
    };

    const pathname = window.location.pathname;
    const activePathname = extractDynamicDigit(pathname);
    setActivePathname(activePathname);

    //eslint-disable-next-line
  }, [window.location.pathname]);

  const setCAdminClientIdValue = (selectedClientId) => {
    setCAdminClientId(parseInt(selectedClientId));
    localStorage.setItem('cAdminClientId', parseInt(selectedClientId));
  };

  return (
    <>
      <SidebarLogo
        sidebarCollapsed={sidebarCollapsed}
        setSidebarCollapsed={setSidebarCollapsed}
      />
      <div className="gx-sidebar-content">
        <div
          className={`gx-sidebar-notifications ${getNoHeaderClass(navStyle)}`}
        >
          <UserProfile />
        </div>

        <CustomScrollbars className="gx-layout-sider-scrollbar">
          <Menu
            defaultOpenKeys={[defaultOpenKeys]}
            selectedKeys={[selectedKeys]}
            theme={themeType === THEME_TYPE_LITE ? "lite" : "dark"}
            mode="inline"
          >
            {authUser.role === "corporateAdmin" && (
              <Menu.Item key="clientSelect">
                <div className="corporate-admin-dropdown">
                  <Form
                    form={form}
                    name="filter-asset-data"
                    className="filter-asset-data-area"
                  >
                    <Form.Item
                      name="cAdminClients"
                      labelAlign="top"
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                    >
                      <Select
                        showSearch
                        style={{ width: "100%" }}
                        className="custom-input"
                        placeholder="Select client"
                        onChange={setCAdminClientIdValue}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        filterSort={(optionA, optionB) =>
                          (optionA?.label ?? "")
                            .toLowerCase()
                            .localeCompare((optionB?.label ?? "").toLowerCase())
                        }
                        options={clientList.map((item, index) => ({
                          value: item.id,
                          label: item.name ? ReactHtmlParser(item.name)[0] : "",
                        }))}
                      />
                    </Form.Item>
                  </Form>
                </div>
              </Menu.Item>
            )}

            <Menu.Item key="dashboard/crm">
              <Link 
                to="/dashboard/crm"
                className={
                  activePathname === "1" ? "active-item " : "not-active "
                }
              >
                <i className="icon icon-dasbhoard" />
                <span>
                  <IntlMessages id="Dashboard" />
                </span>
              </Link>
            </Menu.Item>

            {/* ant-menu-item-active */}
            <Menu.Item key="assets/allAssets">
              <Link
                to="/assets/allAssets"
                className={
                  activePathname === "2" ? "active-item " : "not-active "
                }
              >
                <i className="icon icon-product-list" />
                <span>
                  <IntlMessages id="Assets" />
                </span>
              </Link>
            </Menu.Item>

            <Menu.Item key="clients/allClients">
              <Link
                to="/clients/allClients"
                className={
                  activePathname === "3" ? "active-item " : "not-active "
                }
              >
                <i className="icon icon-diamond" />
                <span>
                  <IntlMessages id="Clients" />
                </span>
              </Link>
            </Menu.Item>

            <Menu.Item key="users/allUsers">
              <Link
                to="/users/allUsers"
                className={
                  activePathname === "4" ? "active-item " : "not-active "
                }
              >
                <i className="icon icon-profile" />
                <span>
                  <IntlMessages id="Users" />
                </span>
              </Link>
            </Menu.Item>

            {authUser.clientId === null && (
              <Menu.Item key="corporateadmin/allAdmins">
                <Link
                  to="/corporateadmin/allAdmins"
                  className={
                    activePathname === "5" ? "active-item " : "not-active "
                  }
                >
                  <i className="icon icon-avatar" />
                  <span>
                    <IntlMessages id="Corporate Admins" />
                  </span>
                </Link>
              </Menu.Item>
            )}

            <Menu.Item key="reports/AllReports">
              <Link to="/reports/AllReports">
                <i className="icon icon-data-display" />
                <span>
                  <IntlMessages id="Reports" />
                </span>
              </Link>
            </Menu.Item>
          </Menu>
        </CustomScrollbars>
      </div>
    </>
  );
};

export default React.memo(SidebarContent);
